import React from 'react';

/** ******************* COMPONENTS ********************** */
import sortCaret from 'components/Table/Others/sortCaret';
import InviteStatus from 'components/Status/InviteStatus';

/** ******************** HELPERS  *************************  */
import { viewDateAndTime } from 'utils/date';
import { Link, IconButton } from '@chakra-ui/react';
import { MdRefresh } from 'react-icons/md';
import { CgDetailsMore } from 'react-icons/cg';

export const InvitedRealtorHeader = ({ tableActions, data })=>{
    return [
        {
            text: 'First Name',
            dataField: 'FirstName',
            formatter: (cell, row, rowIndex, formatExtraData) => {
                return cell;
            }
        },

        {
            text: 'Last Name',
            dataField: 'LastName',
            formatter: (cell, row, rowIndex, formatExtraData) => {
                return cell;
            }
        },

        {
            text: 'Email',
            dataField: 'Email',
            formatter: (cell, row, rowIndex, formatExtraData) => {
                return (
                    <React.Fragment>
                        <Link color='brand.500' href={'mailto:' + cell}>
                            {cell}
                        </Link>
                    </React.Fragment>
                );
            }
        },

        {
            text: 'Status',
            dataField: 'invitationStatus',
            sort: true,
            sortCaret,
            formatter: (value, row) => {
                return (
                    <InviteStatus status={value}/>
                );
            }
        },

        {
            text: 'Sent On',
            dataField: 'createdAt',
            sortCaret,
            sort: true ,
            formatter: (value)=>{
                return viewDateAndTime(value);
            }
        },
        {
            text: 'Action',
            dataField: '_id',
            sortCaret,
            formatter: (cell, row, rowIndex, formatExtraData) => {
                return (
                    <>
                        {
                            row?.invitationStatus !== 'ACCEPTED' &&

                               <IconButton
                                   aria-label="Resend invite"
                                   icon={<MdRefresh/>}
                                   variant="outline"
                                   onClick={(e)=> { e.preventDefault(); formatExtraData?.data?.handleResendInvite(row, formatExtraData?.data?.USERTYPE); }}

                               />
                        }
                        &nbsp;
                        <IconButton
                            aria-label="View Details"
                            icon={<CgDetailsMore/>}
                            variant="outline"
                            onClick={(e)=> { e.preventDefault(); formatExtraData?.data?.handleBulkInviteDetails(row, formatExtraData?.data?.USERTYPE); }}

                        />
                    </>

                );
            } ,
            formatExtraData: tableActions
        }

    ];
};
